<template>
  <Teleport to="body">
    <!-- Overlay oscuro -->
    <div v-if="mostrar" class="perfil-overlay" @click.self="$emit('cerrar')"></div>

    <!-- Panel deslizante -->
    <div class="perfil-panel" :class="{ abierto: mostrar }">
      <div class="panel-header">
        <div class="panel-brand">
          <img src="/icons/icon-192.png" alt="Vedent" class="panel-brand-img" />
          <span class="panel-brand-name">Vedent</span>
        </div>
        <button class="btn-cerrar" @click="$emit('cerrar')">✕</button>
      </div>

      <div class="panel-body">
        <!-- Info del doctor -->
        <div class="info-doctor">
          <div class="avatar">{{ iniciales }}</div>
          <div class="info-textos">
            <p class="info-nombre">{{ usuario?.nombre }} {{ usuario?.apellido }}</p>
            <p class="info-email">{{ usuario?.email }}</p>
            <span class="badge-rol">{{ usuario?.rol === 'admin' ? 'Administrador' : 'Doctor/a' }}</span>
          </div>
        </div>

        <div class="separador"></div>

        <!-- Ajustes -->
        <button class="btn-gcal-toggle" @click="ajustesAbierto = !ajustesAbierto">
          <span>⚙️ Ajustes</span>
          <span class="chevron-gcal" :class="{ 'chevron-gcal-open': ajustesAbierto }">▼</span>
        </button>

        <transition name="slide">
          <div v-if="ajustesAbierto" class="ajustes-contenido">

            <!-- Cada subsección se abre y se cierra sola. Antes estaban todas desplegadas y el
                 panel se hacía larguísimo: había que scrollear un rato para llegar a Guardar. -->

            <!-- Configuración general -->
            <button class="seccion-toggle" @click="alternarSeccion('general')" :aria-expanded="String(secciones.general)">
              <span>Configuración general</span>
              <span class="chevron-seccion" :class="{ 'chevron-seccion-open': secciones.general }">▼</span>
            </button>
            <transition name="slide">
              <div v-if="secciones.general" class="seccion-contenido">
                <!-- Estos son datos de la DOCTORA (no de pacientes), así que el autocompletado del
                     navegador acá le sirve: se usan valores estándar en vez de autocomplete="off". -->
                <div class="campo">
                  <label for="aj-idioma">Idioma</label>
                  <input v-model="formAjustes.idioma" id="aj-idioma" name="aj-idioma" autocomplete="off" placeholder="Español" />
                </div>
                <div class="campo">
                  <label for="aj-pais">País</label>
                  <input v-model="formAjustes.pais" id="aj-pais" name="aj-pais" autocomplete="country-name" placeholder="Uruguay" />
                </div>
              </div>
            </transition>

            <!-- Horario de trabajo -->
            <button class="seccion-toggle" @click="alternarSeccion('horario')" :aria-expanded="String(secciones.horario)">
              <span>Horario de trabajo</span>
              <span class="seccion-resumen">{{ formAjustes.horarioApertura }}–{{ formAjustes.horarioCierre }}</span>
              <span class="chevron-seccion" :class="{ 'chevron-seccion-open': secciones.horario }">▼</span>
            </button>
            <transition name="slide">
              <div v-if="secciones.horario" class="seccion-contenido">
                <div class="campo-fila">
                  <div class="campo">
                    <label for="aj-apertura">Desde</label>
                    <select v-model="formAjustes.horarioApertura" id="aj-apertura" name="aj-apertura">
                      <option v-for="h in opcionesApertura" :key="h" :value="h">{{ h }}</option>
                    </select>
                  </div>
                  <div class="campo">
                    <label for="aj-cierre">Hasta</label>
                    <select v-model="formAjustes.horarioCierre" id="aj-cierre" name="aj-cierre">
                      <option v-for="h in opcionesCierre" :key="h" :value="h">{{ h }}</option>
                    </select>
                  </div>
                </div>
                <p class="campo-hint">{{ resumenHorario }}</p>

                <span class="campo-label-dias">Días que atendés</span>
                <div class="dias-semana">
                  <button
                    v-for="dia in DIAS_SEMANA"
                    :key="dia.clave"
                    type="button"
                    class="btn-dia"
                    :class="{ activo: formAjustes.diasActivos[dia.clave] }"
                    :aria-pressed="String(!!formAjustes.diasActivos[dia.clave])"
                    @click="alternarDia(dia.clave)"
                  >{{ dia.label }}</button>
                </div>
                <p class="campo-hint">
                  En los días apagados no se puede agendar: se ven en gris en el calendario y no
                  aparecen en la vista Semana. Los turnos que ya tengas ahí se siguen viendo.
                </p>
              </div>
            </transition>

            <!-- Preferencias -->
            <button class="seccion-toggle" @click="alternarSeccion('preferencias')" :aria-expanded="String(secciones.preferencias)">
              <span>Preferencias</span>
              <span class="chevron-seccion" :class="{ 'chevron-seccion-open': secciones.preferencias }">▼</span>
            </button>
            <transition name="slide">
              <div v-if="secciones.preferencias" class="seccion-contenido">
                <label class="toggle-pref">
                  <span>Botón "Exportar ficha (PDF)" en el paciente</span>
                  <input
                    type="checkbox"
                    id="aj-exportar-ficha"
                    name="aj-exportar-ficha"
                    :checked="store.usuarioActual?.exportarFichaHabilitado === true"
                    @change="toggleExportarFicha($event.target.checked)"
                  />
                </label>
                <label class="toggle-pref">
                  <span>Facturación: registrar forma de pago (efectivo, débito, crédito…)</span>
                  <input
                    type="checkbox"
                    id="aj-facturacion"
                    name="aj-facturacion"
                    :checked="store.usuarioActual?.mostrarFacturacion === true"
                    @change="toggleFacturacion($event.target.checked)"
                  />
                </label>
              </div>
            </transition>

            <!-- Seguridad. El título ES el botón: antes había que abrir la sección y además
                 tocar "Cambiar contraseña" para ver lo mismo. -->
            <button class="seccion-toggle" @click="alternarSeccion('seguridad')" :aria-expanded="String(secciones.seguridad)">
              <span>Cambiar contraseña</span>
              <span class="chevron-seccion" :class="{ 'chevron-seccion-open': secciones.seguridad }">▼</span>
            </button>
            <transition name="slide">
              <div v-if="secciones.seguridad" class="seccion-contenido">
                <div class="campo">
                  <label for="pass-actual">Contraseña actual</label>
                  <input type="password" v-model="formPass.actual" id="pass-actual" name="pass-actual" placeholder="Tu contraseña actual" autocomplete="current-password" />
                </div>
                <div class="campo">
                  <label for="pass-nueva">Nueva contraseña</label>
                  <input type="password" v-model="formPass.nueva" id="pass-nueva" name="pass-nueva" placeholder="Mínimo 6 caracteres" autocomplete="new-password" />
                </div>
                <div class="campo">
                  <label for="pass-confirmar">Confirmar contraseña</label>
                  <input type="password" v-model="formPass.confirmar" id="pass-confirmar" name="pass-confirmar" placeholder="Repetir contraseña" autocomplete="new-password" />
                </div>
                <div v-if="mensajePass" class="mensaje" :class="mensajePass.tipo">{{ mensajePass.texto }}</div>
                <button class="btn-guardar" @click="cambiarContrasena" :disabled="guardandoPass">
                  {{ guardandoPass ? 'Guardando...' : 'Guardar contraseña' }}
                </button>
              </div>
            </transition>

            <!-- Información profesional -->
            <button class="seccion-toggle" @click="alternarSeccion('profesional')" :aria-expanded="String(secciones.profesional)">
              <span>Información profesional</span>
              <span class="chevron-seccion" :class="{ 'chevron-seccion-open': secciones.profesional }">▼</span>
            </button>
            <transition name="slide">
              <div v-if="secciones.profesional" class="seccion-contenido">
                <div class="campo">
                  <label for="aj-email">Email</label>
                  <input :value="usuario?.email" id="aj-email" name="aj-email" autocomplete="email" disabled class="input-disabled" />
                </div>
                <div class="campo">
                  <label for="aj-nombre">Nombre</label>
                  <input v-model="formAjustes.nombre" id="aj-nombre" name="aj-nombre" autocomplete="given-name" placeholder="Tu nombre" />
                </div>
                <div class="campo">
                  <label for="aj-apellido">Apellido</label>
                  <input v-model="formAjustes.apellido" id="aj-apellido" name="aj-apellido" autocomplete="family-name" placeholder="Tu apellido" />
                </div>
                <div class="campo">
                  <label for="aj-credenciales">Credenciales profesionales</label>
                  <input v-model="formAjustes.credenciales" id="aj-credenciales" name="aj-credenciales" autocomplete="off" placeholder="Ej: Dr. Med, especialista en..." />
                </div>
                <div class="campo">
                  <label for="aj-info">Información</label>
                  <textarea v-model="formAjustes.infoProfesional" id="aj-info" name="aj-info" autocomplete="off" rows="3" placeholder="Descripción profesional..."></textarea>
                </div>
              </div>
            </transition>

            <!-- Información de la clínica -->
            <button class="seccion-toggle" @click="alternarSeccion('clinica')" :aria-expanded="String(secciones.clinica)">
              <span>Información de la clínica</span>
              <span class="chevron-seccion" :class="{ 'chevron-seccion-open': secciones.clinica }">▼</span>
            </button>
            <transition name="slide">
              <div v-if="secciones.clinica" class="seccion-contenido">
                <div class="campo">
                  <label for="aj-telefono">Teléfono</label>
                  <input v-model="formAjustes.telefonoClinica" id="aj-telefono" name="aj-telefono" type="tel" autocomplete="tel" placeholder="+598 9X XXX XXX" />
                </div>
                <div class="campo">
                  <label for="aj-direccion">Dirección</label>
                  <input v-model="formAjustes.direccionClinica" id="aj-direccion" name="aj-direccion" autocomplete="street-address" placeholder="Dirección del consultorio" />
                </div>
                <div class="campo">
                  <label for="aj-localizacion">Localización</label>
                  <input v-model="formAjustes.localizacion" id="aj-localizacion" name="aj-localizacion" autocomplete="address-level2" placeholder="Ej: Montevideo, Uruguay" />
                </div>
              </div>
            </transition>

            <div v-if="mensajeAjustes" class="mensaje" :class="mensajeAjustes.tipo">{{ mensajeAjustes.texto }}</div>
            <button class="btn-guardar" @click="guardarAjustes" :disabled="guardandoAjustes">
              {{ guardandoAjustes ? 'Guardando...' : 'Guardar cambios' }}
            </button>

          </div>
        </transition>

        <div class="separador"></div>

        <!-- Google Calendar -->
        <div v-if="store.usuarioActual?.googleCalendarHabilitado">
          <button class="btn-gcal-toggle" @click="toggleGcal">
            <span>📅 Google Calendar</span>
            <span class="chevron-gcal" :class="{ 'chevron-gcal-open': gcalAbierto }">▼</span>
          </button>

          <div v-if="gcalAbierto" class="gcal-contenido">
            <div class="google-calendar-info">
              <p v-if="!conectado">Conecta tu Google Calendar para exportar tus turnos automáticamente</p>
              <p v-else>✅ Conectado a Google Calendar</p>

              <div class="calendar-buttons">
                <button
                  v-if="!conectado"
                  class="btn-conectar-calendar"
                  @click="manejarConexionCalendar"
                  :disabled="cargando"
                >
                  {{ cargando ? 'Conectando...' : '🔗 Conectar Google Calendar' }}
                </button>

                <template v-else>
                  <button class="btn-exportar-turnos" @click="exportarTurnos" :disabled="cargando">
                    {{ cargando ? 'Exportando...' : '📤 Exportar Todos los Turnos' }}
                  </button>
                  <button class="btn-sincronizar-calendar" @click="sincronizarDesdeGoogleCalendar" :disabled="cargando">
                    {{ cargando ? 'Sincronizando...' : '📥 Importar desde Google Calendar' }}
                  </button>
                  <button class="btn-desconectar-calendar" @click="manejarDesconexionCalendar">
                    🔌 Desconectar
                  </button>
                </template>
              </div>

              <p v-if="mensajeCalendar" :class="['mensaje-calendar', tipoMensajeCalendar]">
                {{ mensajeCalendar }}
              </p>
            </div>
          </div>
        </div>

        <div class="separador"></div>

        <!-- Instalar app -->
        <button v-if="puedeInstalar && !yaInstalada" class="btn-instalar-panel" @click="instalar">
          📲 Instalar app
        </button>

        <div class="separador"></div>

        <!-- Pagar Cuota -->
        <button class="btn-gcal-toggle" @click="toggleCuota">
          <span>💳 Pagar cuota</span>
          <span class="chevron-gcal" :class="{ 'chevron-gcal-open': cuotaAbierto }">▼</span>
        </button>

        <div v-if="cuotaAbierto" class="cuota-contenido">
          <!-- Al día -->
          <div v-if="pagado && !suscripcionVencida" class="cuota-estado cuota-ok">
            <span>✅ Suscripción activa</span>
            <span class="cuota-fecha">Próximo pago: {{ proximaFechaPago }}</span>
          </div>

          <!-- Vencida: 1 mes -->
          <div v-else-if="pagado && mesesVencidos === 1" class="cuota-estado cuota-vencida">
            <span>⚠️ Tu suscripción venció</span>
            <span class="cuota-fecha">Vencida desde: {{ proximaFechaPago }}</span>
            <button class="btn-pagar-panel" @click="pagarCuota">Pagar cuota (${{ precioPlanActual }} UYU)</button>
          </div>

          <!-- Vencida: 2+ meses -->
          <div v-else-if="pagado && mesesVencidos >= 2" class="cuota-estado cuota-critica">
            <span>🔴 {{ mesesVencidos }} cuotas pendientes</span>
            <span class="cuota-fecha">Total: ${{ montoPendiente }} UYU</span>
            <button class="btn-pagar-panel" @click="pagarCuota">Regularizar suscripción</button>
          </div>

          <!-- Nuevo usuario -->
          <div v-else-if="esNuevoUsuario" class="cuota-estado">
            <button class="btn-pagar-panel" @click="verInstrucciones">Contratar plan</button>
          </div>

          <!-- Acceso suspendido -->
          <div v-else class="cuota-estado cuota-vencida">
            <span>⚠️ Tu acceso fue suspendido</span>
            <button class="btn-pagar-panel" @click="pagarCuota">Pagar cuota (${{ precioPlanActual }} UYU)</button>
          </div>
        </div>

        <div class="separador"></div>

        <!-- Legal -->
        <div class="links-legales">
          <RouterLink to="/privacidad" @click="$emit('cerrar')">Política de Privacidad</RouterLink>
          <span>·</span>
          <RouterLink to="/terminos" @click="$emit('cerrar')">Condiciones del Servicio</RouterLink>
        </div>

        <div class="separador"></div>

        <button class="btn-cerrar-sesion" @click="cerrarSesion">
          Cerrar sesión
        </button>
      </div>
    </div>
  </Teleport>

  <!-- Modal de pago -->
  <Teleport to="body">
    <div v-if="mostrarModalPago" class="modal-overlay" @click.self="cerrarModalPago">
      <div class="modal-content modal-pago">
        <button class="btn-cerrar" @click="cerrarModalPago">×</button>
        <h2>{{ esRenovacion ? 'Instrucciones de renovación' : 'Instrucciones de Pago' }}</h2>

        <!-- Selector de plan (oculto si hay cuotas atrasadas: es solo renovación mensual) -->
        <div v-if="!(esRenovacion && mesesVencidos > 1)" class="selector-plan-panel">
          <p class="selector-plan-titulo">Elegí tu plan:</p>
          <div class="planes-panel">
            <button
              class="plan-card-panel"
              :class="{ activa: planSeleccionado === 'mensual' }"
              @click="planSeleccionado = 'mensual'"
              type="button"
            >
              <span class="plan-nombre-panel">Mensual</span>
              <span class="plan-precio-panel">$590 <small>UYU/mes</small></span>
            </button>
            <button
              class="plan-card-panel"
              :class="{ activa: planSeleccionado === 'anual' }"
              @click="planSeleccionado = 'anual'"
              type="button"
            >
              <span class="plan-badge-panel">2 meses gratis</span>
              <span class="plan-nombre-panel">Anual</span>
              <span class="plan-precio-panel">$5.900 <small>UYU/año</small></span>
            </button>
          </div>
        </div>

        <div class="plan-seleccionado">
          <strong>{{ esRenovacion ? 'Renovación:' : 'Plan seleccionado:' }}</strong>
          {{ esRenovacion && mesesVencidos > 1
            ? `${mesesVencidos} cuotas atrasadas - $${montoPendiente} UYU`
            : `Cuota ${nombrePlan} - $${precio.toLocaleString('es-UY')} UYU` }}
        </div>
        <div class="instrucciones-pago">
          <p class="coordinar-texto">
            Para activar tu plan coordinamos el pago por WhatsApp: te paso los datos y, al
            confirmar la transferencia, tu cuenta queda activa.
          </p>
          <a :href="linkPagoWhatsapp" target="_blank" class="btn-whatsapp">
            💬 Coordinar pago por WhatsApp
          </a>
        </div>
      </div>
    </div>
  </Teleport>

  <!-- Modal Eventos Pendientes de Google Calendar -->
  <Teleport to="body">
    <div v-if="eventosPendientes.length > 0" class="modal-overlay">
      <div class="modal-content modal-importar">
        <h2>📅 Importar desde Google Calendar</h2>
        <p class="importar-subtitulo">
          Se encontraron <strong>{{ eventosPendientes.length }}</strong> evento(s) nuevos.
          Revisá cada uno y asignale un paciente antes de importar.
        </p>

        <div
          v-for="evento in eventosPendientes"
          :key="evento.googleEventId"
          class="evento-pendiente-card"
        >
          <div class="evento-info">
            <strong>{{ evento.titulo }}</strong>
            <span class="evento-fecha">{{ evento.fecha }} · {{ evento.inicio }}–{{ evento.fin }}</span>
            <span v-if="evento.descripcion" class="evento-descripcion">{{ evento.descripcion }}</span>
          </div>

          <div class="evento-acciones">
            <div class="toggle-modo-paciente">
              <button
                :class="['btn-modo', modoNuevoPaciente[evento.googleEventId] ? '' : 'activo']"
                @click="modoNuevoPaciente[evento.googleEventId] = false"
              >
                Paciente existente
              </button>
              <button
                :class="['btn-modo', modoNuevoPaciente[evento.googleEventId] ? 'activo' : '']"
                @click="modoNuevoPaciente[evento.googleEventId] = true"
              >
                Crear nuevo
              </button>
            </div>

            <!-- id/name dinámicos: estos campos se repiten por cada evento importado. -->
            <select
              v-if="!modoNuevoPaciente[evento.googleEventId]"
              v-model="seleccionPaciente[evento.googleEventId]"
              :id="'imp-sel-' + evento.googleEventId"
              :name="'imp-sel-' + evento.googleEventId"
              class="select-paciente"
            >
              <option value="" disabled selected>Seleccionar paciente</option>
              <option
                v-for="p in pacientesStore.pacientes.filter(p => p.activo !== false)"
                :key="p.id"
                :value="p.id"
              >
                {{ p.nombre }}
              </option>
            </select>

            <div v-else class="campos-nuevo-paciente">
              <div class="campos-nombre-row">
                <input
                  v-model="nuevoPacienteForm[evento.googleEventId].nombre"
                  :id="'imp-nombre-' + evento.googleEventId"
                  :name="'imp-nombre-' + evento.googleEventId"
                  autocomplete="off"
                  placeholder="Nombre"
                  class="input-nuevo-paciente"
                />
                <input
                  v-model="nuevoPacienteForm[evento.googleEventId].apellido"
                  :id="'imp-apellido-' + evento.googleEventId"
                  :name="'imp-apellido-' + evento.googleEventId"
                  autocomplete="off"
                  placeholder="Apellido"
                  class="input-nuevo-paciente"
                />
              </div>
              <template v-if="tieneDuplicadoNombre(evento.googleEventId)">
                <p class="aviso-duplicado-import">Ya existe un paciente con ese nombre. Agregá CI/RUT o segundo apellido para distinguirlos.</p>
                <input
                  v-model="nuevoPacienteForm[evento.googleEventId].segundoApellido"
                  :id="'imp-apellido2-' + evento.googleEventId"
                  :name="'imp-apellido2-' + evento.googleEventId"
                  autocomplete="off"
                  placeholder="Segundo apellido (ej: López)"
                  class="input-nuevo-paciente"
                />
              </template>
              <input
                v-model="nuevoPacienteForm[evento.googleEventId].ci"
                :id="'imp-ci-' + evento.googleEventId"
                :name="'imp-ci-' + evento.googleEventId"
                autocomplete="off"
                placeholder="Documento (CI / RUT)"
                class="input-nuevo-paciente"
              />
            </div>

            <div class="evento-btns">
              <button
                class="btn-importar-evento"
                :disabled="!puedeImportar(evento)"
                @click="aceptarEvento(evento)"
              >
                ✅ Importar
              </button>
              <button class="btn-rechazar-evento" @click="rechazarImportacion(evento.googleEventId)">
                ✖ Descartar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useUsuariosStore } from '@/stores/usuarios';
import { usePacientesStore } from '@/stores/pacientes';
import { useGoogleCalendar } from '@/composables/useGoogleCalendar';
import { useInstallPrompt } from '@/composables/useInstallPrompt';
import { useScrollLock } from '@/composables/useScrollLock';
import { useRouter } from 'vue-router';
import { getAuth, updatePassword, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { fechaPagadoHasta, mesesVencidos as calcMesesVencidos, esNuevoUsuario as calcEsNuevoUsuario } from '@/utils/suscripcion';
import { linkWhatsApp } from '@/constants/contacto';
import { aMinutos, aHHMM, normalizarDiasActivos, DIAS_SEMANA, APERTURA_DEFECTO, CIERRE_DEFECTO } from '@/utils/horarios';

const props = defineProps({
  mostrar: { type: Boolean, default: false }
});

const emit = defineEmits(['cerrar']);

// Bloquear el scroll del fondo mientras el panel está abierto (igual que los demás modales).
useScrollLock(() => props.mostrar);

const store = useUsuariosStore();
const { puedeInstalar, yaInstalada, instalar } = useInstallPrompt();
const pacientesStore = usePacientesStore();
const router = useRouter();

// Pagar Cuota
const cuotaAbierto = ref(false);
const ajustesAbierto = ref(false);

// Subsecciones de Ajustes, todas cerradas al abrir el panel. Se abre solo la que se toca
// (acordeón): con varias abiertas volvía el problema de tener que scrollear hasta Guardar.
const secciones = ref({
  general: false,
  horario: false,
  preferencias: false,
  seguridad: false,
  profesional: false,
  clinica: false,
});

function alternarSeccion(nombre) {
  const abrir = !secciones.value[nombre];
  for (const clave of Object.keys(secciones.value)) secciones.value[clave] = false;
  secciones.value[nombre] = abrir;
}

function cerrarSecciones() {
  for (const clave of Object.keys(secciones.value)) secciones.value[clave] = false;
}
const mostrarModalPago = ref(false);
const esRenovacion = ref(false);

const PRECIOS = { mensual: 590, anual: 5900 };

const pagado = computed(() => store.usuarioActual?.pagoPendiente === false);
const esNuevoUsuario = computed(() => calcEsNuevoUsuario(store.usuarioActual));
const planActualUsuario = computed(() => store.usuarioActual?.plan === 'anual' ? 'anual' : 'mensual');
const precioPlanActual = computed(() => PRECIOS[planActualUsuario.value]);

const planSeleccionado = ref('mensual');
const precio = computed(() => PRECIOS[planSeleccionado.value]);
const nombrePlan = computed(() => planSeleccionado.value === 'anual' ? 'Anual' : 'Mensual');
// Link de WhatsApp con el plan/monto elegido, para coordinar el pago en privado.
const linkPagoWhatsapp = computed(() => {
  const detalle = esRenovacion.value && mesesVencidos.value > 1
    ? `regularizar mi suscripción (${mesesVencidos.value} cuotas, $${montoPendiente.value} UYU)`
    : `${esRenovacion.value ? 'renovar' : 'contratar'} el plan ${nombrePlan.value} de Vedent ($${precio.value} UYU)`;
  return linkWhatsApp(`Hola Francisco, quiero ${detalle}. ¿Cómo coordino el pago?`);
});

const mesesVencidos = computed(() =>
  pagado.value ? calcMesesVencidos(store.usuarioActual) : 0
);

const suscripcionVencida = computed(() => mesesVencidos.value > 0);
const montoPendiente = computed(() => mesesVencidos.value * PRECIOS.mensual);

const proximaFechaPago = computed(() => {
  const ph = fechaPagadoHasta(store.usuarioActual);
  if (!ph) return '';
  return ph.toLocaleDateString('es-UY', { day: '2-digit', month: '2-digit', year: 'numeric' });
});

function toggleCuota() {
  cuotaAbierto.value = !cuotaAbierto.value;
}

function pagarCuota() {
  esRenovacion.value = true;
  planSeleccionado.value = planActualUsuario.value;
  mostrarModalPago.value = true;
}

function verInstrucciones() {
  esRenovacion.value = false;
  planSeleccionado.value = planActualUsuario.value;
  mostrarModalPago.value = true;
}

function cerrarModalPago() {
  mostrarModalPago.value = false;
}

// Preferencia por doctora: muestra/oculta el botón "Exportar ficha (PDF)" en el paciente.
// Se guarda en su perfil para que la siga en todos sus dispositivos.
async function toggleExportarFicha(habilitar) {
  await store.actualizarPerfil({ exportarFichaHabilitado: habilitar });
}

// Preferencia por doctora: en los planes de tratamiento, muestra la forma de pago
// (efectivo/débito/crédito/transferencia) al cobrar. Apagado = solo monto y fecha.
async function toggleFacturacion(habilitar) {
  await store.actualizarPerfil({ mostrarFacturacion: habilitar });
}


// Google Calendar
const gcalAbierto = ref(false);
const mensajeCalendar = ref('');
const tipoMensajeCalendar = ref('');
const seleccionPaciente = ref({});
const modoNuevoPaciente = ref({});
const nuevoPacienteForm = ref({});

const {
  conectado,
  cargando,
  eventosPendientes,
  conectarGoogleCalendar,
  desconectarGoogleCalendar,
  exportarTodosLosTurnos,
  sincronizarDesdeCalendar,
  confirmarImportacion,
  rechazarImportacion,
  reconectarSilencioso,
} = useGoogleCalendar();

async function toggleGcal() {
  gcalAbierto.value = !gcalAbierto.value;
  if (gcalAbierto.value && !conectado.value) {
    await reconectarSilencioso();
  }
}

async function manejarConexionCalendar() {
  const resultado = await conectarGoogleCalendar();
  mensajeCalendar.value = resultado.mensaje;
  tipoMensajeCalendar.value = resultado.exito ? 'exito' : 'error';
  setTimeout(() => { mensajeCalendar.value = ''; }, 5000);
}

function manejarDesconexionCalendar() {
  const resultado = desconectarGoogleCalendar();
  mensajeCalendar.value = resultado.mensaje;
  tipoMensajeCalendar.value = resultado.exito ? 'exito' : 'error';
  setTimeout(() => { mensajeCalendar.value = ''; }, 3000);
}

async function exportarTurnos() {
  const resultado = await exportarTodosLosTurnos();
  mensajeCalendar.value = resultado.mensaje;
  tipoMensajeCalendar.value = resultado.exito ? 'exito' : 'error';
  setTimeout(() => { mensajeCalendar.value = ''; }, 5000);
}

async function sincronizarDesdeGoogleCalendar() {
  const resultado = await sincronizarDesdeCalendar();
  mensajeCalendar.value = resultado.mensaje;
  tipoMensajeCalendar.value = resultado.exito ? 'exito' : 'error';
  if (resultado.exito && resultado.pendientes > 0) {
    eventosPendientes.value.forEach(e => {
      seleccionPaciente.value[e.googleEventId] = '';
      modoNuevoPaciente.value[e.googleEventId] = false;
      nuevoPacienteForm.value[e.googleEventId] = {
        nombre: e.pacienteSugerido?.split(' ')[0] || '',
        apellido: e.pacienteSugerido?.split(' ').slice(1).join(' ') || '',
        ci: '',
        segundoApellido: '',
      };
    });
  }
  setTimeout(() => { mensajeCalendar.value = ''; }, 5000);
}

function tieneDuplicadoNombre(eventId) {
  const form = nuevoPacienteForm.value[eventId];
  if (!form?.nombre?.trim() || !form?.apellido?.trim()) return false;
  const nombreCompleto = `${form.nombre.trim()} ${form.apellido.trim()}`.toLowerCase();
  return pacientesStore.pacientes.some(
    (p) => p.activo !== false && p.nombre.toLowerCase() === nombreCompleto
  );
}

function puedeImportar(evento) {
  const id = evento.googleEventId;
  if (modoNuevoPaciente.value[id]) {
    const form = nuevoPacienteForm.value[id];
    if (!form?.nombre?.trim() || !form?.apellido?.trim()) return false;
    if (tieneDuplicadoNombre(id)) return !!(form.ci?.trim() || form.segundoApellido?.trim());
    return true;
  }
  return !!seleccionPaciente.value[id];
}

async function aceptarEvento(evento) {
  const id = evento.googleEventId;
  let pacienteId, nombrePaciente;
  if (modoNuevoPaciente.value[id]) {
    const form = nuevoPacienteForm.value[id];
    const nombre = form.nombre.trim();
    const apellido = form.apellido.trim();
    const segundoApellido = form.segundoApellido?.trim() || '';
    const ci = form.ci?.trim() || '';
    if (!nombre || !apellido) return;
    if (tieneDuplicadoNombre(id) && !ci && !segundoApellido) return;
    // El apellido real incluye el segundo apellido cuando se usó para desambiguar.
    const apellidoCompleto = [apellido, segundoApellido].filter(Boolean).join(' ');
    const nombreCompleto = [nombre, apellidoCompleto].filter(Boolean).join(' ');
    try {
      const nuevo = await pacientesStore.agregarPaciente({ nombre: nombreCompleto, apellido: apellidoCompleto, ci });
      pacienteId = nuevo.id;
      nombrePaciente = nombreCompleto;
    } catch (e) {
      mensajeCalendar.value = e.message || 'No se pudo crear el paciente';
      tipoMensajeCalendar.value = 'error';
      setTimeout(() => { mensajeCalendar.value = ''; }, 3000);
      return;
    }
  } else {
    pacienteId = seleccionPaciente.value[id];
    if (!pacienteId) return;
    const paciente = pacientesStore.pacientes.find(p => p.id === pacienteId);
    nombrePaciente = paciente ? paciente.nombre : evento.pacienteSugerido;
  }
  const resultado = confirmarImportacion(evento, pacienteId, nombrePaciente, evento.motivoSugerido);
  if (!resultado.exito) {
    mensajeCalendar.value = resultado.mensaje;
    tipoMensajeCalendar.value = 'error';
    setTimeout(() => { mensajeCalendar.value = ''; }, 5000);
    return;
  }
  delete seleccionPaciente.value[id];
  delete modoNuevoPaciente.value[id];
  delete nuevoPacienteForm.value[id];
  mensajeCalendar.value = `Turno importado: ${nombrePaciente}`;
  tipoMensajeCalendar.value = 'exito';
  setTimeout(() => { mensajeCalendar.value = ''; }, 3000);
}

const usuario = computed(() => store.usuarioActual);

const iniciales = computed(() => {
  const n = usuario.value?.nombre?.[0] || '';
  const a = usuario.value?.apellido?.[0] || '';
  return (n + a).toUpperCase() || '?';
});

const formAjustes = ref({
  idioma: '',
  pais: '',
  horarioApertura: '',
  horarioCierre: '',
  pausaDesde: '',
  pausaHasta: '',
  diasActivos: { lun: true, mar: true, mie: true, jue: true, vie: true, sab: true, dom: true },
  nombre: '',
  apellido: '',
  credenciales: '',
  infoProfesional: '',
  telefonoClinica: '',
  direccionClinica: '',
  localizacion: '',
});

// Horario de trabajo: horas en punto. "Hasta" es el fin de la jornada, así que el último turno
// arranca media hora antes (hasta las 20:00 → último turno 19:30–20:00).
const opcionesApertura = Array.from({ length: 23 }, (_, h) => aHHMM(h * 60)); // 00:00–22:00

const opcionesCierre = computed(() => {
  const desde = aMinutos(formAjustes.value.horarioApertura) ?? 0;
  const horas = [];
  for (let m = desde + 60; m <= 24 * 60; m += 60) horas.push(m === 24 * 60 ? '24:00' : aHHMM(m));
  return horas;
});

// Si el usuario atrasa la apertura hasta pasar el cierre, el valor elegido en "Hasta" deja de
// estar en la lista y el select se ve vacío. Se corre solo a la hora siguiente.
watch(() => formAjustes.value.horarioApertura, (desde) => {
  const ini = aMinutos(desde);
  const fin = aMinutos(formAjustes.value.horarioCierre);
  if (ini === null || fin === null || fin > ini) return;
  formAjustes.value.horarioCierre = aHHMM(ini + 60);
});

function alternarDia(clave) {
  formAjustes.value.diasActivos = {
    ...formAjustes.value.diasActivos,
    [clave]: !formAjustes.value.diasActivos[clave],
  };
}

const resumenHorario = computed(() => {
  const desde = formAjustes.value.horarioApertura;
  const hasta = formAjustes.value.horarioCierre;
  const finMin = aMinutos(hasta);
  if (aMinutos(desde) === null || finMin === null) return '';
  return `Tu agenda va a mostrar turnos de ${desde} a ${hasta}: el último empieza ${aHHMM(finMin - 30)}. ` +
         'Los turnos que ya tengas fuera de ese horario se siguen viendo.';
});

const formPass = ref({ actual: '', nueva: '', confirmar: '' });
const guardandoAjustes = ref(false);
const guardandoPass = ref(false);
const mensajeAjustes = ref(null);
const mensajePass = ref(null);

// ¿El formulario llegó a cargarse con los datos del usuario? Mientras sea false, `formAjustes`
// tiene los strings vacíos del arranque y guardar BORRARÍA el perfil.
const formCargado = ref(false);

function cargarFormAjustes() {
  const u = usuario.value;
  if (!u) return;
  // OJO: `horarioApertura`/`horarioCierre` se venían guardando solos desde abril de 2026 (el
  // formulario los mandaba con sus valores por defecto aunque no hubiera campos en pantalla).
  // Por eso solo se leen si `horarioConfigurado` confirma que el usuario los eligió: si no,
  // se muestra el horario real que tiene hoy la agenda y guardar no le cambia nada.
  const horarioElegido = u.horarioConfigurado === true;
  formAjustes.value = {
    idioma: u.idioma || 'Español',
    pais: u.pais || 'Uruguay',
    horarioApertura: (horarioElegido && u.horarioApertura) || APERTURA_DEFECTO,
    horarioCierre: (horarioElegido && u.horarioCierre) || CIERRE_DEFECTO,
    pausaDesde: u.pausaDesde || '',
    pausaHasta: u.pausaHasta || '',
    diasActivos: normalizarDiasActivos(u.diasActivos),
    nombre: u.nombre || '',
    apellido: u.apellido || '',
    credenciales: u.credenciales || '',
    infoProfesional: u.infoProfesional || '',
    telefonoClinica: u.telefonoClinica || '',
    direccionClinica: u.direccionClinica || u.direccionTrabajo || '',
    localizacion: u.localizacion || '',
  };
  formCargado.value = true;
}

watch(() => props.mostrar, (val) => {
  if (!val) return;
  formCargado.value = false;
  cargarFormAjustes();
  mensajeAjustes.value = null;
  formPass.value = { actual: '', nueva: '', confirmar: '' };
  mensajePass.value = null;
  cerrarSecciones();
});

// Si el panel se abrió ANTES de que Firebase terminara de traer el usuario, el `watch` de arriba
// encontraba `usuario` en null, dejaba el formulario vacío y no lo reintentaba nunca: se veían
// todos los campos en blanco y, si se tocaba Guardar, se escribían vacíos encima del perfil.
// Ahora en cuanto llega el usuario se completa solo. La guarda `!formCargado` evita pisar lo que
// se esté tipeando si el store se refresca con el panel abierto.
watch(usuario, () => {
  if (props.mostrar && !formCargado.value) cargarFormAjustes();
});

async function guardarAjustes() {
  // Cinturón de seguridad: nunca mandar a Firestore un formulario que no llegó a cargarse.
  if (!formCargado.value) {
    mensajeAjustes.value = { tipo: 'error', texto: 'Todavía se están cargando tus datos. Esperá un momento y volvé a intentar.' };
    return;
  }

  const desde = aMinutos(formAjustes.value.horarioApertura);
  const hasta = aMinutos(formAjustes.value.horarioCierre);
  if (desde === null || hasta === null || hasta <= desde) {
    mensajeAjustes.value = { tipo: 'error', texto: 'La hora de cierre tiene que ser posterior a la de apertura.' };
    return;
  }
  if (!DIAS_SEMANA.some(({ clave }) => formAjustes.value.diasActivos?.[clave])) {
    mensajeAjustes.value = { tipo: 'error', texto: 'Elegí al menos un día de atención.' };
    return;
  }

  guardandoAjustes.value = true;
  mensajeAjustes.value = null;
  const resultado = await store.actualizarPerfil({
    idioma: formAjustes.value.idioma.trim(),
    pais: formAjustes.value.pais.trim(),
    horarioApertura: formAjustes.value.horarioApertura,
    horarioCierre: formAjustes.value.horarioCierre,
    // Marca que el horario ya no es el que venía por defecto, sino uno elegido a propósito.
    horarioConfigurado: true,
    pausaDesde: formAjustes.value.pausaDesde,
    pausaHasta: formAjustes.value.pausaHasta,
    diasActivos: formAjustes.value.diasActivos,
    nombre: formAjustes.value.nombre.trim(),
    apellido: formAjustes.value.apellido.trim(),
    credenciales: formAjustes.value.credenciales.trim(),
    infoProfesional: formAjustes.value.infoProfesional.trim(),
    telefonoClinica: formAjustes.value.telefonoClinica.trim(),
    direccionClinica: formAjustes.value.direccionClinica.trim(),
    localizacion: formAjustes.value.localizacion.trim(),
  });
  guardandoAjustes.value = false;
  if (resultado.exito) {
    mensajeAjustes.value = { tipo: 'exito', texto: 'Cambios guardados correctamente.' };
    setTimeout(() => { mensajeAjustes.value = null; }, 3000);
  } else {
    mensajeAjustes.value = { tipo: 'error', texto: resultado.mensaje || 'No se pudo guardar.' };
  }
}

async function cambiarContrasena() {
  mensajePass.value = null;
  if (!formPass.value.actual) {
    mensajePass.value = { tipo: 'error', texto: 'Ingresá tu contraseña actual.' };
    return;
  }
  if (formPass.value.nueva.length < 6) {
    mensajePass.value = { tipo: 'error', texto: 'La contraseña nueva debe tener al menos 6 caracteres.' };
    return;
  }
  if (formPass.value.nueva !== formPass.value.confirmar) {
    mensajePass.value = { tipo: 'error', texto: 'Las contraseñas no coinciden.' };
    return;
  }
  guardandoPass.value = true;
  try {
    const user = getAuth().currentUser;
    if (!user || !user.email) throw new Error('sin-sesion');

    // Reautenticar con la contraseña ACTUAL antes de cambiarla. Firebase lo exige para
    // operaciones sensibles (por eso antes fallaba siempre con sesiones de varios días),
    // y de paso impide que alguien con el teléfono desbloqueado la cambie sin conocerla.
    const credencial = EmailAuthProvider.credential(user.email, formPass.value.actual);
    await reauthenticateWithCredential(user, credencial);
    await updatePassword(user, formPass.value.nueva);

    mensajePass.value = { tipo: 'exito', texto: 'Contraseña actualizada correctamente.' };
    formPass.value = { actual: '', nueva: '', confirmar: '' };
    setTimeout(() => { secciones.value.seguridad = false; mensajePass.value = null; }, 2000);
  } catch (e) {
    let texto = 'No se pudo cambiar la contraseña. Probá de nuevo.';
    if (e.code === 'auth/wrong-password' || e.code === 'auth/invalid-credential') {
      texto = 'La contraseña actual es incorrecta.';
    } else if (e.code === 'auth/too-many-requests') {
      texto = 'Demasiados intentos. Esperá un momento y probá de nuevo.';
    } else if (e.code === 'auth/weak-password') {
      texto = 'La contraseña nueva es muy débil (mínimo 6 caracteres).';
    } else if (e.message === 'sin-sesion') {
      texto = 'Tu sesión no está disponible. Cerrá sesión y volvé a entrar.';
    }
    mensajePass.value = { tipo: 'error', texto };
  } finally {
    guardandoPass.value = false;
  }
}

async function cerrarSesion() {
  await store.logout();
  emit('cerrar');
  router.push('/login');
}
</script>

<style scoped>
.perfil-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3000;
}

.perfil-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 320px;
  max-width: 100vw;
  /* 100dvh (no 100vh): en Safari el 100vh es más alto que la pantalla visible y
     cortaba el botón "Cerrar sesión" del fondo. */
  height: 100dvh;
  background: white;
  z-index: 3001;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
  transform: translateX(100%);
  transition: transform 0.3s ease;
  font-family: system-ui, sans-serif;
}

.perfil-panel.abierto {
  transform: translateX(0);
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 16px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.panel-brand {
  display: flex;
  align-items: center;
  gap: 8px;
}

.panel-brand-img {
  width: 32px;
  height: 32px;
  border-radius: 8px;
}

.panel-brand-name {
  font-family: "Krub", sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #678AB2;
}

.btn-cerrar {
  background: none;
  border: none;
  font-size: 20px;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  line-height: 1;
  transition: background 0.2s;
}

.btn-cerrar:hover {
  background: #f3f4f6;
  color: #374151;
}

.panel-body {
  flex: 1;
  overflow-y: auto;
  /* Margen extra abajo = franja segura del iPhone, para que "Cerrar sesión" no quede tapado. */
  padding: 20px 16px calc(20px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Info doctor */
.info-doctor {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #678AB2, #4d6f96);
  color: white;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-textos {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.info-nombre {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-email {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-rol {
  font-size: 11px;
  font-weight: 600;
  color: #678AB2;
  background: #eff6ff;
  padding: 2px 8px;
  border-radius: 20px;
  display: inline-block;
}

.separador {
  height: 1px;
  background: #e5e7eb;
  margin: 4px 0;
}

.seccion-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

/* Campos */
.campo {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.campo label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.campo input,
.campo textarea,
.campo select {
  width: 100%;
  padding: 9px 10px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  font-size: 14px;
  font-family: system-ui, sans-serif;
  box-sizing: border-box;
  resize: vertical;
  transition: border-color 0.2s;
}

.campo select {
  background: #fff;
  color: #111827;
  resize: none;
  cursor: pointer;
}

.campo input:focus,
.campo textarea:focus,
.campo select:focus {
  outline: none;
  border-color: #678AB2;
  box-shadow: 0 0 4px rgba(103, 138, 178, 0.3);
}

.campo-hint {
  font-size: 11px;
  color: #9ca3af;
  line-height: 1.4;
}

/* Mensaje feedback */
.mensaje {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
}

.mensaje.exito {
  background: #d1fae5;
  color: #065f46;
}

.mensaje.error {
  background: #fee2e2;
  color: #991b1b;
}

/* Botones */
.btn-guardar {
  width: 100%;
  padding: 12px;
  background: #678AB2;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-guardar:hover:not(:disabled) {
  background: #4d6f96;
}

.btn-guardar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-cerrar-sesion {
  width: 100%;
  padding: 11px;
  background: #fee2e2;
  color: #dc2626;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-cerrar-sesion:hover {
  background: #fecaca;
}

/* Google Calendar en panel */
.btn-gcal-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-gcal-toggle:hover {
  background: #f3f4f6;
}

.chevron-gcal {
  font-size: 11px;
  color: #9ca3af;
  transition: transform 0.2s;
}

.chevron-gcal-open {
  transform: rotate(180deg);
}

.gcal-contenido {
  margin-top: 10px;
  background: linear-gradient(135deg, #4285f4 0%, #34a853 100%);
  border-radius: 12px;
  padding: 20px;
  color: white;
}

.consultorio-contenido {
  margin-top: 10px;
}

.ajustes-contenido {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.toggle-pref {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  color: #374151;
  padding: 6px 0;
}

.toggle-pref input {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* Encabezado plegable de cada subsección de Ajustes. Mantiene el look del título de antes
   (versalitas azules con línea abajo) pero es un botón: se toca para abrir y cerrar. */
.seccion-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  border-bottom: 1px solid #e5e7eb;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #678AB2;
  text-align: left;
  margin-top: 10px;
  padding: 8px 2px 6px;
  cursor: pointer;
  transition: color 0.15s;
}

.seccion-toggle:hover {
  color: #4d6f96;
}

.seccion-toggle:focus-visible {
  outline: 2px solid #678AB2;
  outline-offset: 2px;
}

/* Valor actual al lado del título (hoy solo el horario), para no tener que abrir la sección
   para saber cómo quedó. */
.seccion-resumen {
  margin-left: auto;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}

.chevron-seccion {
  margin-left: auto;
  font-size: 9px;
  color: #9ca3af;
  transition: transform 0.2s;
}

/* Cuando hay resumen, el chevron va pegado a él y no empujado al borde. */
.seccion-resumen + .chevron-seccion {
  margin-left: 0;
}

.chevron-seccion-open {
  transform: rotate(180deg);
}

.seccion-contenido {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 0 4px;
}

.campo-fila {
  display: flex;
  gap: 10px;
}

.campo-fila .campo {
  flex: 1;
}

/* Rótulo de los días. Es un <span> y no un <label>: no rotula un input concreto sino un grupo
   de botones, y un <label> sin `for` válido es HTML inválido (ya nos pasó en HistoriaClinica). */
.campo-label-dias {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin-top: 6px;
}

.dias-semana {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.btn-dia:focus-visible {
  outline: 2px solid #678AB2;
  outline-offset: 2px;
}

.btn-dia {
  flex: 1;
  min-width: 36px;
  padding: 6px 2px;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  background: #f9fafb;
  color: #6b7280;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-dia.activo {
  background: #678AB2;
  border-color: #678AB2;
  color: white;
}

.input-disabled {
  background: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
}

.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.google-calendar-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.google-calendar-info p {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.95);
}

.calendar-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.btn-conectar-calendar,
.btn-exportar-turnos,
.btn-sincronizar-calendar,
.btn-desconectar-calendar {
  background: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-conectar-calendar { color: #4285f4; }
.btn-exportar-turnos { color: #34a853; }
.btn-sincronizar-calendar { color: #1a73e8; }
.btn-desconectar-calendar { color: #ea4335; }

.btn-conectar-calendar:hover,
.btn-exportar-turnos:hover,
.btn-sincronizar-calendar:hover,
.btn-desconectar-calendar:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.btn-conectar-calendar:disabled,
.btn-exportar-turnos:disabled,
.btn-sincronizar-calendar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.mensaje-calendar {
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
}

.mensaje-calendar.exito {
  background: rgba(52, 168, 83, 0.2);
  border: 2px solid rgba(52, 168, 83, 0.5);
  color: #e8f8f0;
}

.mensaje-calendar.error {
  background: rgba(234, 67, 53, 0.2);
  border: 2px solid rgba(234, 67, 53, 0.5);
  color: #fde8e8;
}

/* Modal importar desde GCal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.modal-content.modal-importar {
  background: white;
  border-radius: 16px;
  padding: 24px;
  max-width: 520px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
}

.modal-content.modal-importar h2 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #111827;
}

.importar-subtitulo {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 16px;
}

.evento-pendiente-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
}

.evento-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.evento-fecha {
  font-size: 13px;
  color: #6b7280;
}

.evento-descripcion {
  font-size: 13px;
  color: #9ca3af;
}

.evento-acciones {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.toggle-modo-paciente {
  display: flex;
  gap: 8px;
}

.btn-modo {
  flex: 1;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  background: white;
  color: #6b7280;
  transition: all 0.2s;
}

.btn-modo.activo {
  background: #678AB2;
  color: white;
  border-color: #678AB2;
}

.select-paciente {
  width: 100%;
  padding: 9px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
}

.campos-nuevo-paciente {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.campos-nombre-row {
  display: flex;
  gap: 8px;
}

.input-nuevo-paciente {
  flex: 1;
  padding: 9px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
}

.aviso-duplicado-import {
  font-size: 12px;
  color: #f59e0b;
  margin: 0;
}

.evento-btns {
  display: flex;
  gap: 8px;
}

.btn-importar-evento {
  flex: 1;
  padding: 10px;
  background: #678AB2;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.btn-importar-evento:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-rechazar-evento {
  padding: 10px 16px;
  background: #fee2e2;
  color: #dc2626;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

/* Instalar app */
.btn-instalar-panel {
  width: 100%;
  padding: 12px 14px;
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #15803d;
  cursor: pointer;
  text-align: left;
  transition: background 0.2s;
}

.btn-instalar-panel:hover {
  background: #dcfce7;
}

/* Links legales */
.links-legales {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #9ca3af;
  justify-content: center;
}

.links-legales a {
  color: #6b7280;
  text-decoration: none;
}

.links-legales a:hover {
  color: #678AB2;
  text-decoration: underline;
}

/* Cuota mensual */
.cuota-contenido {
  margin-top: 10px;
}

.cuota-estado {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border-radius: 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  color: #374151;
}

.cuota-ok {
  background: #d1fae5;
  border-color: #6ee7b7;
  color: #065f46;
}

.cuota-vencida {
  background: #fef3c7;
  border-color: #fcd34d;
  color: #92400e;
}

.cuota-critica {
  background: #fee2e2;
  border-color: #fca5a5;
  color: #991b1b;
}

.cuota-fecha {
  font-size: 12px;
  opacity: 0.8;
}

.btn-pagar-panel {
  margin-top: 4px;
  padding: 9px 14px;
  background: #678AB2;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-pagar-panel:hover {
  background: #4d6f96;
}

.cuota-vencida .btn-pagar-panel,
.cuota-critica .btn-pagar-panel {
  background: #f97316;
}

.cuota-vencida .btn-pagar-panel:hover,
.cuota-critica .btn-pagar-panel:hover {
  background: #ea6c0a;
}

/* Modal de pago */
.modal-pago {
  background: white;
  border-radius: 16px;
  padding: 24px;
  max-width: 420px;
  width: 90%;
  position: relative;
}

.modal-pago h2 {
  margin: 0 0 12px;
  font-size: 18px;
  color: #111827;
}

.plan-seleccionado {
  background: #eff6ff;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  color: #1e40af;
  margin-bottom: 16px;
}

.instrucciones-pago h3 {
  font-size: 14px;
  color: #374151;
  margin: 0 0 12px;
}

.dato-bancario {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
}

.dato-bancario label {
  color: #6b7280;
  font-size: 12px;
  flex-shrink: 0;
  margin-right: 8px;
}

.valor-pago {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #111827;
}

.valor-pago.destacado-pago {
  color: #678AB2;
  font-weight: 700;
}

.btn-copiar-panel {
  padding: 3px 10px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  color: #374151;
  transition: background 0.2s;
}

.btn-copiar-panel:hover {
  background: #e5e7eb;
}

.nota-pago {
  margin-top: 16px;
  background: #fef3c7;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 13px;
  color: #92400e;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nota-pago p {
  margin: 0;
}

.link-pago {
  color: #1d4ed8;
  font-weight: 600;
  text-decoration: none;
}

.coordinar-texto {
  font-size: 14px;
  line-height: 1.5;
  color: #4b5563;
  margin: 0 0 14px;
}

.btn-whatsapp {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #25D366;
  color: #fff;
  text-decoration: none;
  padding: 14px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 15px;
}

.btn-whatsapp:hover {
  background: #1ebe5d;
}

.link-pago:hover {
  text-decoration: underline;
}

/* Selector de plan dentro del modal de pago */
.selector-plan-panel {
  margin-bottom: 14px;
}

.selector-plan-titulo {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.planes-panel {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.plan-card-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 10px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  font-family: system-ui, sans-serif;
  transition: all 0.15s;
}

.plan-card-panel:hover {
  border-color: #cbd5e1;
}

.plan-card-panel.activa {
  border-color: #678AB2;
  background: #eff6ff;
  box-shadow: 0 0 0 2px rgba(103, 138, 178, 0.15);
}

.plan-nombre-panel {
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.plan-precio-panel {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.plan-precio-panel small {
  font-size: 10px;
  font-weight: 500;
  color: #6b7280;
}

.plan-badge-panel {
  position: absolute;
  top: -7px;
  right: 6px;
  background: #678AB2;
  color: white;
  font-size: 9px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}
</style>
